<template>
	<div>
		<div class="header-box">
			<div class="headerImg">
				<div class="nav-box overflow">
					<div class="pull-l">
						<span>Evergreen Inspiration</span>
						<br/>
						<span>Technology</span>
					</div>
					<ul class="pull-r marginTop">
						<li class="pull-l marginRight"><router-link to="/">首页</router-link></li>
						<li class="pull-l marginRight"><router-link to="/mall">麦卡通商城</router-link></li>
						<li class="pull-l "><router-link to="/aboutUs">关于我们</router-link></li>
					</ul>
				</div>
				<div class="title pull-l">
					<div class="t1 text-l">企业服务 礼品服务</div>
					<div class="t2 text-c">Corporate Services & Gift Services</div>
					<div class="t3 text-r">策划 / 运营 / 服务</div>
				</div>
			</div>
		</div>
		<router-view></router-view>
		<div class="footer posi-r">
			<styleysOne :classId='"style-four"'></styleysOne>
			<div class="conent">
				<div class="li pull-l marginRight">
					<img src="@/assets/img/home/code1.png" alt="" class="code">
					<div class="title text-c">微信公众号</div>
				</div>
				<div class="li pull-l">
					<img src="@/assets/img/home/code2.png" alt="" class="code">
					<div class="title text-c">麦卡通商城</div>
				</div>
				<div class="pull-l titleConent">
					<div class="title ">关于我们</div>
					<div class="title ">About US</div>
					<div class="title ">九丰互联，</div>
					<div class="title ">是专业的自选礼品服务提供商，</div>
					<div class="title ">为公司以及个人提供贴心以及个性化的全程礼赠解决方案。</div>
				</div>
			</div>
		</div>
	</div>
	
</template>



<script>
	import styleysOne from '../../components/style.vue'
	export default {
		name: 'Header',
		components: {
			styleysOne,
		},
		created() {
			(function() {
			  var html = document.documentElement;
			  var windowClientHeight = html.clientHeight;
			  html.style.fontSize = (html.clientHeight / windowClientHeight) + 'px';
			  // console.log(html.clientHeight)
			  window.onresize = function() {
			    html.style.fontSize = (html.clientHeight / windowClientHeight) + 'px';
			    // console.log(html.clientHeight)
			    // console.log("html.clientHeight / html.clientHeight", html.clientHeight / html.clientHeight)
			  };
			})();
			
		},
	}
</script>
<style scoped>
	.footer{
		width:100%;
		height:650rem;
		margin-top:60rem;
		background: url("../../assets/img/home/footer.png") no-repeat;
		background-size: 100% 650rem;
	}
	
	.footer .conent{
		margin-left:180rem;
	}
	.footer .titleConent{
		margin-left:120rem;
		margin-top:298rem;
	}
	.footer .marginRight{
		margin-right:20rem
	}
	.footer .title{
		font-size:18rem;
		color:#fff;
		margin:10rem 0
	}
	.footer .li{
		margin-top:280rem;
		width:156rem;
		height:156rem;
		
	}
	.footer .code{
		width:100%;
		height:100%
	}
	.header-box{
		width:100%;
		height:850rem;
		background: url("../../assets/img/home/headerbox.png") no-repeat;
		background-size: 100% 100%;
		
	}
	.header-box .headerImg{
		width:100%;
		height:100%;
		display: block;
	}
	.header-box .headerImg{
		width:100%;
		height:100%;
		background: url("../../assets/img/home/headerImg.png") no-repeat;
		background-size: 100% 100%;
	}
	.header-box .nav-box{
		padding-left: 195rem;
		padding-top:50rem;
		padding-right:150rem;
		font-size:24rem;
		color:#fff;
	}
	.header-box .marginRight{
		margin-right:100rem
	}
	.header-box .marginTop{
		
		margin-top:20rem;
		
	}
	.header-box .marginTop a{
		font-size:20rem;
		color:#fff;
	}
	.header-box .marginTop .router-link-exact-active{
	 	color: orange !important;
	 }
	.header-box  .title{
		margin-top:120rem;
		margin-left: 195rem;
		color:#fff;
	}
	.header-box  .t1{
		font-size:38rem;
	}
	.header-box .t2{
		margin:10rem 0;
		font-size:16rem;
	}
	.header-box .t3{
		font-size:14rem;
		margin-right:20rem
	}
</style>